import PropTypes from 'prop-types'
import Borde from './Borde'
import IndicarCategorias from './IndicarCategorias'

export const PublicacionMasiva = ({ errores, handleChange }) => {
  return (
    <div>
      <Borde titulo="Selecciona una categoria" activo={true} error={errores.idCategoria}>
        <IndicarCategorias onChange={handleChange} esMasiva={true} />
      </Borde>
    </div>
  )
}

PublicacionMasiva.propTypes = {
  errores: PropTypes.shape({
    idCategoria: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired,
  handleChange: PropTypes.func.isRequired
}
